// extracted by mini-css-extract-plugin
export default {"Board":"Board_Board__zvS8j"};